import AccordionComponent from "./components/accordion";
import BackToTop from "./components/back-to-top";
import BrowserDetectComponent from "./components/browser-detect";
import ExpandableComponent from "./components/expandable";
import CommonModal from "./components/modal";
import PasswordToggle from "./components/password-toggle";
import Preload from "./components/preload";
import { scroll } from "./components/scroll";
import ScrollSpy from "./components/scrollspy";
import ScrollTo from "./components/scrollto";

import NewsletterComponent from "./components/newsletter";
import ShopifyClient from "./components/shopify-client";

window.scroller = scroll;

window.ShopifyClient = new ShopifyClient("355c6398f60df7f6b05304372fb5fc6b");
if (location.hostname == "hepeu-f-store.myshopify.com") {
  window.ShopifyClient = new ShopifyClient("8ae0a2ee3ab5fe5b9550c9a121fbbbf1");
}

Preload.init();
BrowserDetectComponent.init();
AccordionComponent.init();
ExpandableComponent.init();

BackToTop.init(scroll);
CommonModal.init(scroll);
ScrollTo.init();
ScrollSpy.init(scroll);
PasswordToggle.init();
NewsletterComponent.init();

import Wishlist from "./common/wishlist";
const wishlist = Wishlist();
wishlist.initialize();

// Home
import "./sections/header";
import "./sections/menu-drawer";
import "./sections/search-drawer";

import "./sections/section-media-grid";
import "./sections/section-mobile-cart-modal";
import "./sections/section-special";
import "./sections/section-news-list";

// sections
import "./sections/brand-articles";
import "./sections/cart-form";
import "./sections/cart-header";
import "./sections/collection-grid";
import "./sections/customers-login-2023.js";
import "./sections/media-grid-2023";
import "./sections/media-grid-products-shopify";
import "./sections/media-slider-articles";
import "./sections/media-slider-products-history";
import "./sections/media-slider-products-algolia";
import "./sections/media-slider-products-shopify";
import "./sections/media-slider-products-recommend";
import "./sections/media-slider-snaps";
import "./sections/product-2023";
import "./sections/section-popup-header";
import "./sections/popup-index";

// snnipets
import "./snippets/header-nav-pc";
import "./snippets/header-nav-sp";
import "./snippets/menu-drawer-store-sp";
import "./snippets/menu-drawer-store-sp-submenu";
import "./snippets/product-2023-content-love-is-you";
import "./snippets/brand-grid-abc";
import "./snippets/brand-menu-abc";

// templates
import "./templates/page-favorite";
import "./templates/page-snap";
import "./templates/page-shopping-guide";

console.log(window.fstore);
